export const HappinessIndexCreate = ({ content, lastPath }) => {
    const currentContent = content(lastPath)

    return (
        <div className="relative">
            <div className={"absolute font-medium text-md text-primary-60 right-12 py-6"}>
                {`Step ${currentContent?.sequence} of 2`}
            </div>
            <div>
                {currentContent?.item}
            </div>
        </div>
    )
}
